import React, { useState } from "react";
import axios from "axios";
import "./style.css";

const Contact = () => {
  const [formState, setFormState] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [buttonState, setButtonState] = useState("");
  const [hasError, setHasError] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setButtonState("loading");

    try {
      // await axios.post('https://invalid-url.com', formState);
      await axios.post("https://formspree.io/f/xgejaawv", formState);
      setButtonState("sent");
    } catch (error) {
      console.error("An error occurred while sending the form:", error);
      setButtonState("");
      setHasError(true);
      setTimeout(() => {
        setHasError(false);
      }, 5 * 60 * 1000);
    }
  };

  const buttonClass = `btn btn-primary ${buttonState}`;

  return (
    <section className="contact" id="contact">
      <div className="contact-content section-content">
        <p className="section-subtitle">Contact</p>
        <h2 className="h3 section-title">Start Your Project Journey with Me</h2>
        <p className="section-text">
          Whether you have a project in mind or just a spark of an idea, I'm
          here to help bring it to life. Reach out, and I'll get back to you
          shortly!
        </p>
        <ul className="contact-list">
          <li className="contact-list-item">
            <div className="contact-item-icon">
              <ion-icon name="location-outline"></ion-icon>
            </div>
            <div className="wrapper">
              <h3 className="h4 contact-item-title">Address:</h3>
              <address className="contact-info">
                @Argentina. Worldwide, Remote.
              </address>
            </div>
          </li>
          <li className="contact-list-item">
            <div className="contact-item-icon">
              <ion-icon name="call-outline"></ion-icon>
            </div>
            <div className="wrapper">
              <h3 className="h4 contact-item-title">Phone:</h3>
              <a className="contact-info" href="tel:01234567789">
                (+54) 911 6262 7500
              </a>
              <a className="contact-info" href="tel:09765432200">
                (+54) 911 3672 2436
              </a>
            </div>
          </li>
          <li className="contact-list-item">
            <div className="contact-item-icon">
              <ion-icon name="mail-outline"></ion-icon>
            </div>
            <div className="wrapper">
              <h3 className="h4 contact-item-title">Email:</h3>
              <a className="contact-info" href="mailto:info@salterain.com.ar">
                info@salterain.com.ar
              </a>
              <a
                className="contact-info"
                href="mailto:support@salterain.com.ar"
              >
                support@salterain.com.ar
              </a>
            </div>
          </li>
          <li>
            <ul className="contact-social-list">
              <li>
                <a
                  className="contact-social-link"
                  href="https://www.facebook.com/Verlaire/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="tooltip">Facebook</div>
                  <ion-icon name="logo-facebook"></ion-icon>
                </a>
              </li>
              <li>
                <a
                  className="contact-social-link"
                  href="https://dribbble.com/Verlaire"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="tooltip">Dribbble</div>
                  <ion-icon name="logo-dribbble"></ion-icon>
                </a>
              </li>
              <li>
                <a
                  className="contact-social-link"
                  href="https://www.linkedin.com/in/gsaltera/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="tooltip">Linkedin</div>
                  <ion-icon name="logo-linkedin"></ion-icon>
                </a>
              </li>
              <li>
                <a
                  className="contact-social-link"
                  href="https://github.com/Verlaire"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="tooltip">GitHub</div>
                  <ion-icon name="logo-github"></ion-icon>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <form action="" className="contact-form" onSubmit={handleSubmit}>
        <div className="form-wrapper">
          <label className="form-label" htmlFor="name">
            Name
          </label>
          <div className="input-wrapper">
            <input
              className="input-field"
              id="name"
              name="name"
              placeholder="e.g John Doe"
              required
              type="text"
              onChange={handleChange}
            />
            <ion-icon name="person-circle"></ion-icon>
          </div>
        </div>
        <div className="form-wrapper">
          <label className="form-label" htmlFor="email">
            Email
          </label>
          <div className="input-wrapper">
            <input
              className="input-field"
              id="email"
              name="email"
              placeholder="e.g johndoe@mail.com"
              required
              type="email"
              onChange={handleChange}
            />
            <ion-icon name="mail"></ion-icon>
          </div>
        </div>
        <div className="form-wrapper">
          <label className="form-label" htmlFor="phone">
            Phone
          </label>
          <div className="input-wrapper">
            <input
              className="input-field"
              id="phone"
              name="phone"
              placeholder="Phone Number"
              required
              type="tel"
              onChange={handleChange}
            />
            <ion-icon name="call"></ion-icon>
          </div>
        </div>
        <div className="form-wrapper">
          <label className="form-label" htmlFor="message">
            Message
          </label>
          <div className="input-wrapper">
            <textarea
              className="input-field"
              id="message"
              name="message"
              placeholder="Write message..."
              required
              type="tel"
              onChange={handleChange}
            ></textarea>
            <ion-icon name="chatbubbles"></ion-icon>
          </div>
        </div>
        {hasError ? (
          <p className="error-message section-text">
            <ion-icon name="alert-circle-outline"></ion-icon> Error sending.
            Please try again in 5 minutes.
          </p>
        ) : (
          <button
            className={buttonClass}
            type="submit"
            disabled={buttonState === "loading" || buttonState === "sent"}
          >
            {buttonState === "loading"
              ? "loading..."
              : buttonState === "sent"
              ? "Thank you!"
              : "Send"}
          </button>
        )}
      </form>
    </section>
  );
};

export default Contact;
